import { THEME_NAMES } from "./config";
import { assetPackIds } from "nemuru-components";

export const hofmannTheme = {
  zendeskCustomerSupport: true,
  themeName: THEME_NAMES.hofmann,
  logoUrl: "https://cdn.nemuru.com/assets/logos/hofmann-logo.png",
  palette: {
    primary: {
      main: "#17199a",
      contrastText: "#fff",
    },
    secondary: {
      main: "#182258",
      contrastText: "#fff",
    },
    warning: {
      main: "#ffca28",
      contrastText: "#ffffff",
      light: "rgba(255, 202, 40, 0.15)",
    },
    info: {
      main: "#0693e3",
      contrastText: "#ffffff",
      light: "#eaf0f6",
    },
    success: {
      main: "#00bda5",
      contrastText: "#ffffff",
      light: "rgba(0,189,165,0.15)",
    },
    error: {
      main: "#ef5957",
      contrastText: "#ffffff",
      light: "rgba(239,87,87,0.15)",
    },
    text: {
      title: "#182258",
      primary: "#1b1b19",
      secondary: "#3c3b39",
    },
    // additional colors
    dark: {
      main: "#e5e5e5",
      accent: "#17199a",
      contrastText: "#000",
      imageBackgroundOpacity: 0.8,
    },
    status: {
      active: "#00bda5",
      approved: "#007b79",
      analysing: "#0693e3",
      sent: "#182258",
      cancelled: "#d8d8d8",
      denied: "#ef5957",
    },
    grey: {
      50: "#fafafa",
      100: "#f5f5f2",
      200: "#eae9e6",
      300: "#dad9d6",
      400: "#b6b5b2",
      500: "#969593",
      600: "#6e6d6b",
      700: "#5a5a57",
      800: "#3c3b39",
      900: "#1b1b19",
    },
  },
  assetPackDefsId: assetPackIds.OUTLINED,
  background: "#f3f3f3",
  customBorderRadius: {
    button: 5,
    paper: 10,
    chip: 6,
  },
};
